import * as React from "react";
const SvgTop = (props) => /* @__PURE__ */ React.createElement("svg", { width: 18, height: 18, viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M4 11.5L9 6.5L14 11.5", stroke: "#808080", strokeWidth: 1.6, strokeLinecap: "round", strokeLinejoin: "round" }));
export default SvgTop;
